import type { SagaIterator } from 'redux-saga';
import { takeLatest } from 'redux-saga/effects';

import { resourceSagaUtils, resourceStoreTypes } from '../core';
import * as actions from './accountsBalancesHistoryActions';
import {
  type AccountsBalancesHistoryPage,
  type AccountsBalancesHistoryPageProps,
  mkAccountsBalancesHistory,
} from './accountsBalancesHistoryTypes';

type AccountsBalancesHistoryResponse = {
  data?: {
    resources?: AccountsBalancesHistoryPageProps[];
  };
};

const mkAccountsBalancesHistoryResourceConfig =
  resourceStoreTypes.createTypedQcsSyncResourcesConfigFactory<AccountsBalancesHistoryPageProps>();

const mkResourceConfig = () =>
  mkAccountsBalancesHistoryResourceConfig({
    resourceName: 'accounts-balances-history',
    resourceBaseUrl: '/reports/balances-over-time',
    successAction: actions.getAccountsBalancesHistorySuccess,
    failureAction: actions.getAccountsBalancesHistoryFailure,
    transformResponseToResources: (
      response?: AccountsBalancesHistoryResponse | null,
    ): AccountsBalancesHistoryPage[] | undefined =>
      response?.data?.resources?.map((data) => mkAccountsBalancesHistory(data)),
  });

export function* getAccountsBalancesHistoryActionWatcher(): SagaIterator {
  const resourceConfig = mkResourceConfig();
  // TODO: add reportsSagaUtils and genericSagaUtils
  yield takeLatest(
    actions.getAccountsBalancesHistory.type,
    resourceSagaUtils.qcsSyncGetResources<AccountsBalancesHistoryPageProps>,
    resourceConfig,
  );
}

export default [getAccountsBalancesHistoryActionWatcher];
